import comp from "./GenerateTranscriptsButton";
export default comp;
